<template>
<div class="chapter">
<div class="inner_page">
<p class="break"> </p>
<p class="table2">T<span class="small">ABLES</span></p>
<p class="bigspace">
</p><p class="table"><span href="#/html/16_chap5#tbl1" title="Link target outside of Sample">T<span class="small">ABLE</span> O<span class="small">NE</span></span></p>
<p class="table1"><span href="#/html/16_chap5#tbl1" title="Link target outside of Sample">Table of Comparisons: Yalkut And Maseket</span></p>
<p class="xsmallspace">
</p><p class="table"><span href="#/html/16_chap5#tbl2" title="Link target outside of Sample">T<span class="small">ABLE</span> T<span class="small">WO</span></span></p>
<p class="table1"><span href="#/html/16_chap5#tbl2" title="Link target outside of Sample">Table of Comparsions: The Roles of The Relevant Chief Rabbis</span></p>
<p class="xsmallspace">
</p><p class="table"><span href="#/html/16_chap5#tbl3" title="Link target outside of Sample">T<span class="small">ABLE</span> T<span class="small">HREE</span></span></p>
<p class="table1"><span href="#/html/16_chap5#tbl3" title="Link target outside of Sample">Listing of The Nasi’im (Chief Rabbis) of The Great Sanhedrin</span></p>
<p class="xsmallspace">
</p><p class="table"><span href="#/html/16_chap5#tbl4" title="Link target outside of Sample">T<span class="small">ABLE</span> F<span class="small">OUR</span></span></p>
<p class="table1"><span href="#/html/16_chap5#tbl4" title="Link target outside of Sample">Messianic Jewish “Nasi’im” of This Early Community</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_tables.vue?4365dfa4